import React from 'react';
import SectionWrapper from '../../../../components/sectionWrapper/sectionWrapper';
import { styles } from './styles';

const CLAIMS = [
  {
    title: 'Same games',
    body: 'Add the games you play and the platforms you play them on. If the platform doesn\'t matter to you, turn on cross-platform.',
  },
  {
    title: 'Same hours',
    body: 'Set your weekly gaming hours. PlayerCafe works out the time zones, so overlapping hours mean you\'re both actually free.',
  },
  {
    title: 'Made for playing',
    body: 'Swipe right to send a request, left to pass. Once someone accepts, you\'re connected and can start chatting. It\'s for finding teammates, not dates.',
  },
];

export default function Overview(): JSX.Element {

  return (
    <SectionWrapper
      id="about"
      label="What it is"
      heading="Find people you'll actually play with"
      sub="PlayerCafe connects you on the two things that decide whether a session happens: what you play, and when."
     
    >
      <div className="pc-overview" style={styles.grid}>
        {CLAIMS.map((claim) => (
          <div key={claim.title} style={styles.claim}>
            <h3 style={styles.title}>{claim.title}</h3>
            <p style={styles.body}>{claim.body}</p>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );

}
